import { ServerModelWithDateStrings } from "@teamprevent/common/utils";
import axios, { AxiosResponse } from "axios";

import {
    CustomerCategoryListModel,
    CustomerCategoryDetailModel,
    CustomerCategoryFormModel
} from "./model";

class CustomerCategoryApi {

    private readonly apiUrl = "/api/customerCategory";
    private getAllAbortController = new AbortController();

    public async getAll(): Promise<CustomerCategoryListModel[]> {
        this.getAllAbortController.abort();
        this.getAllAbortController = new AbortController();

        const response = await axios.get<ServerModelWithDateStrings<CustomerCategoryListModel>[]>(this.apiUrl, { signal: this.getAllAbortController.signal });
        const data = response.data;
        return data.map(this.parseModel);
    }

    public async detail(id: any): Promise<CustomerCategoryDetailModel> {
        const response = await axios.get<ServerModelWithDateStrings<CustomerCategoryListModel>>(`${this.apiUrl}/${id}`);
        const model = response.data;
        return this.parseModel(model);
    }

    public async save(customerCategory: CustomerCategoryFormModel): Promise<CustomerCategoryDetailModel> {
        const response = await axios.put<CustomerCategoryFormModel, AxiosResponse<ServerModelWithDateStrings<CustomerCategoryListModel>>>(
            `${this.apiUrl}/${customerCategory.id}`,
            customerCategory);
        const model = response.data;
        return this.parseModel(model);
    }

    public async create(customerCategory: CustomerCategoryFormModel): Promise<CustomerCategoryDetailModel> {
        const response = await axios.post<CustomerCategoryFormModel, AxiosResponse<ServerModelWithDateStrings<CustomerCategoryListModel>>>(
            `${this.apiUrl}`,
            customerCategory);
        const model = response.data;
        return this.parseModel(model);
    }

    public async delete(customerCategoryId: string): Promise<void> {
        await axios.delete(`${this.apiUrl}/${customerCategoryId}`);
    }

    public parseModel(model: CustomerCategoryDetailModel): CustomerCategoryDetailModel {
        return {
            ...model
        };
    }
}

export const customerCategoryApi = new CustomerCategoryApi();
